module.exports = __webpack_public_path__ + "img/Selbstbildnis.330943cb.jpg";